module.exports = __webpack_public_path__ + "static/media/subscription-block.3da0bb76.jpg";